import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as PartnersActions from '../actions/partners.actions';
import * as PartnersSelectors from '../selectors/partners.selectors';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  partners$ = this.store.pipe(select(PartnersSelectors.getPartners));
  partnersRequest$ = this.store.pipe(
    select(PartnersSelectors.getPartnerRequest)
  );

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(showLinked: boolean) {
    if (showLinked) {
      this.store.dispatch(PartnersActions.loadPartnersPromotions());
    }
    this.store.dispatch(PartnersActions.loadPartners());
    this.store.dispatch(PartnersActions.loadAEMErrorMessages());
  }
}
